import { createAxiosInstance } from "./index";
import hostConfig from "@/config/hostResolver";

const baseUrl = process.env.VUE_APP_PROGRAM_V3_URL ?? `${hostConfig.apiBaseUrl}/program-service-ts`;

class ProgramClaimServiceV3 {
  get apiClient() {
    if (!this._apiClient) this._apiClient = createAxiosInstance(baseUrl);
    return this._apiClient;
  }

  async getEligibleForms() {
    const response = await this.apiClient?.get(`/v3/program/claim/eligible-forms`, {
      errorContext: "Failed to get eligible forms",
    });
    return response?.data?.rows || [];
  }
}

export default ProgramClaimServiceV3;
